module.exports = __webpack_public_path__ + "static/media/word-logo.fab21e14.png";